/**
 *   Wyświetla okno modalne do ćwiczeń
 */

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import ExpandIcon from "@material-ui/icons/SettingsOverscan";
import ExpandOffIcon from "@material-ui/icons/Crop169";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import {
  HISTORY,
  DRAMA,
  CONCERT,
  WORDS,
  EVALUATION,
  HOT_POINTS,
  WORD_GAME,
  HOW_LANG_WORKS,
  DIALOGUES,
  FILE,
  SAY,
  GRAMMAR,
  DIY,
  THE_WORDS,
  JEOPARDY,
  MOST_USEFUL,
  LEARN_BY_HEART,
  MATCH_IT,
  ORDER_THEM,
  WORD_NETWORK,
  OPPOSITES,
  TALK_TO_ME,
  AT_HOME,
  READ_UNDERSTAND,
  CARDS,
  LISTEN_UNDERSTAND,
  PLAY_IT,
  PAIRS,
  VISUALIZE,
  QUIZ,
  CURIOSITIES,
  THE_OTHER,
} from "../../redux/types";
import Drama from "./Drama";
import Concert from "./Concert";
import Words from "./Words";
import HotPoints from "./HotPoints";
import {
  getExercise,
  setDefaultExercise,
  saveStats,
  addExerciseAttempt,
  markAsFinished,
  refreshCourseSections,
  refreshCourseSection,
  getBackendStats,
} from "../../redux/actions";
import "./index.scss";
import ActionMenu from "./ActionMenu";
import IconButton from "@material-ui/core/IconButton";
// import TestingExercise from './TestingExercise';
import StatsInfo from "./StatsInfo";
import WordGame from "./WordGame";
import HowLangWorks from "./HowLangWorks";
import Dialogues from "./Dialogues";
import Evaluation from "./Evaluation";
// import File from './File';
import Dictionary from "./Dictionary";
import Grammar from "./Grammar";
import Say from "./Say";
import Jeopardy from "./Jeopardy";
// import NewExercise from './NewExercise';
import TheWords from "./TheWords";
import Diy from "./Diy";
import MostUseful from "./MostUseful";
import LearnByHeart from "./LearnByHeart";
import MatchIt from "./MatchIt";
import OrderThem from "./OrderThem";
import TheOther from "./TheOther";
import WordNetwork from "./WordNetwork";
import Opposites from "./Opposites";
import TalkToMe from "./TalkToMe";
import AtHome from "./AtHome";
import ReadAndUnderstand from "./ReadAndUnderstand";
import Cards from "./Cards";
import ListenAndUnderstand from "./ListenAndUnderstand";
import PlayIt from "./PlayIt";
import Pairs from "./Pairs";
import Visualize from "./Visualize";
import Quiz from "./Quiz";
import Curiosities from "./Curiosities";
import NotAvail from "./NotAvail";
import Verbs from "./Verbs";
import History from "./History";
import Comer from "./Comer";

let statsInterval = 0;

function Exercises(props) {
  const params = useParams();
  const match = useRouteMatch();
  const [expand, toggleExpand] = useState(false);
  const { media, currentSection, mobile } = props;
  const { course, tab, unit } = params;
  const [bookmark, setBookmark] = useState({ title: "", link: "" });
  const courseId = props.userState.currentCourseId;
  let currentPart = false;
  if (currentSection && currentSection.parts.length > 0)
    currentPart = currentSection.parts.find(
      (par) => par.slug === params.exercise
    );
  const { title, elementType } = currentPart;
  const id = currentPart.id ? `${currentPart.type}_${currentPart.id}` : null;
  const type = currentPart.type ? currentPart.type : currentPart.elementType;
  const history = useHistory();
  const linkBack = `/kurs/${course}/${tab}/${unit}`;

  const handleClose = () => {
    const secs = props.stats.stopTime();
    props.saveStats(elementType, secs);
    history.push(linkBack);
    props.refreshCourseSections();
    props.refreshCourseSection(props.currentSection.id);
    props.getBackendStats();
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const onExpand = () => {
    toggleExpand(!expand);
    if (props.pwa) return;
    if (expand) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    } else {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen &&
          document.documentElement.requestFullscreen();
      }
    }
  };

  const finishExercise = () => {
    props.markAsFinished(currentPart);
  };

  const updateDefaultLink = () => {
    if (!courseId) return;
    const exerciseTitle = `${currentSection.title}, ${title}`;
    const link = match.url;
    setBookmark({ title: exerciseTitle, link });
    props.setDefaultExercise(exerciseTitle, link, parseInt(id));
  };

  useEffect(() => {
    if (!id || !elementType) return;
    updateDefaultLink();
    if (!props.exercises[id]) {
      props.getExercise(currentPart);
    }
    props.addExerciseAttempt();
    statsInterval = setInterval(() => {
      const secs = props.stats.getTime();
      if (secs < 30) return;
      props.stats.resetTime();
      props.saveStats(elementType, secs);
    }, 5000);
    return () => {
      clearInterval(statsInterval);
    };
    // eslint-disable-next-line
  }, [id, type, elementType]);

  if (!courseId || !currentSection || currentSection.parts.length === 0)
    return "";
  const exercise = props.exercises[id];
  const exerciseProps = {
    close: handleClose,
    params,
    match,
    type,
    exercise,
    expand,
    onExpand,
    part: currentPart,
    finishExercise,
    media,
    startStats: props.stats.startTime,
    action: props.stats.action,
  };

  return (
    <div>
      <Modal open={true} className={expand ? "ex-modal-full" : "ex-modal"}>
        <div className="ex-paper">
          <div className="ex-header">
            <div className="ex-header-left" title="menu akcji">
              <ActionMenu
                bookmark={bookmark}
                options={{ type, option: "exercise", title }}
              />
            </div>
            <div className="ex-title">
              {title} {props.testing && <StatsInfo />}
            </div>
            <div className="ex-header-right">
              {!expand && (
                <IconButton
                  onClick={onExpand}
                  title="włączenie trybu rozszeżonego"
                >
                  <ExpandIcon />
                </IconButton>
              )}
              {expand && (
                <IconButton
                  onClick={onExpand}
                  title="wyłączenie trybu rozszeżonego"
                >
                  <ExpandOffIcon />
                </IconButton>
              )}
              <IconButton onClick={handleClose} title="zamknij okno">
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div className="ex-body">
            {type === HISTORY && exercise && (
              <History exerciseProps={exerciseProps} />
            )}
            {type === DRAMA && exercise && (
              <Drama exerciseProps={exerciseProps} />
            )}
            {type === CONCERT && exercise && (
              <Concert exerciseProps={exerciseProps} />
            )}
            {type === WORDS && exercise && (
              <Words exerciseProps={exerciseProps} />
            )}
            {type === HOT_POINTS && exercise && !mobile && (
              <HotPoints exerciseProps={exerciseProps} />
            )}
            {type === HOT_POINTS && exercise && mobile && (
              <NotAvail exerciseProps={exerciseProps} />
            )}
            {type === WORD_GAME && exercise && (
              <WordGame exerciseProps={exerciseProps} />
            )}
            {type === DIALOGUES && exercise && (
              <Dialogues exerciseProps={exerciseProps} />
            )}
            {type === HOW_LANG_WORKS && exercise && (
              <HowLangWorks exerciseProps={exerciseProps} />
            )}
            {type === EVALUATION && exercise && (
              <Evaluation exerciseProps={exerciseProps} />
            )}
            {type === SAY && exercise && <Say exerciseProps={exerciseProps} />}
            {type === GRAMMAR && exercise && (
              <Grammar exerciseProps={exerciseProps} />
            )}
            {type === FILE &&
              exercise?.file?.url ===
                "/resources/contentFile/236/~category.html" && (
                <Dictionary exerciseProps={exerciseProps} />
              )}
            {type === FILE &&
              exercise?.file?.url ===
                "/resources/contentFile/237/verbtable.html" && (
                <Verbs exerciseProps={exerciseProps} />
              )}
            {type === FILE &&
              exercise?.file?.url ===
                "/resources/contentFile/630/~comer_4.png" && (
                <Comer exerciseProps={exerciseProps} />
              )}
            {type === DIY && exercise && <Diy exerciseProps={exerciseProps} />}
            {type === THE_WORDS && exercise && (
              <TheWords exerciseProps={exerciseProps} />
            )}
            {type === JEOPARDY && exercise && (
              <Jeopardy exerciseProps={exerciseProps} />
            )}

            {type === MOST_USEFUL && exercise && (
              <MostUseful exerciseProps={exerciseProps} />
            )}
            {type === LEARN_BY_HEART && exercise && (
              <LearnByHeart exerciseProps={exerciseProps} />
            )}
            {type === MATCH_IT && exercise && (
              <MatchIt exerciseProps={exerciseProps} />
            )}
            {type === ORDER_THEM && exercise && (
              <OrderThem exerciseProps={exerciseProps} />
            )}
            {type === THE_OTHER && exercise && (
              <TheOther exerciseProps={exerciseProps} />
            )}
            {type === WORD_NETWORK && exercise && (
              <WordNetwork exerciseProps={exerciseProps} />
            )}
            {type === OPPOSITES && exercise && (
              <Opposites exerciseProps={exerciseProps} />
            )}
            {type === TALK_TO_ME && exercise && (
              <TalkToMe exerciseProps={exerciseProps} />
            )}
            {type === AT_HOME && exercise && (
              <AtHome exerciseProps={exerciseProps} />
            )}
            {type === READ_UNDERSTAND && exercise && (
              <ReadAndUnderstand exerciseProps={exerciseProps} />
            )}
            {type === CARDS && exercise && (
              <Cards exerciseProps={exerciseProps} />
            )}
            {type === LISTEN_UNDERSTAND && exercise && (
              <ListenAndUnderstand exerciseProps={exerciseProps} />
            )}
            {type === PLAY_IT && exercise && (
              <PlayIt exerciseProps={exerciseProps} />
            )}
            {type === PAIRS && exercise && (
              <Pairs exerciseProps={exerciseProps} />
            )}
            {type === VISUALIZE && exercise && (
              <Visualize exerciseProps={exerciseProps} />
            )}
            {type === QUIZ && exercise && (
              <Quiz exerciseProps={exerciseProps} />
            )}
            {type === CURIOSITIES && exercise && (
              <Curiosities exerciseProps={exerciseProps} />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    exercises: state.exercises,
    media: state.media,
    userState: state.userState,
    testing: state.config.main.testing,
    stats: state.stats,
    mobile: state.mobile,
    pwa: state.auth.browser.pwa,
  };
};

export default connect(mapStateToProps, {
  getExercise,
  setDefaultExercise,
  refreshCourseSections,
  refreshCourseSection,
  saveStats,
  addExerciseAttempt,
  markAsFinished,
  getBackendStats,
})(Exercises);
